import { Col, Input, Row, Select, Tooltip, message, Button, Radio } from "antd";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { CSVLink } from "react-csv";
import { useSearchParams } from "react-router-dom";
const { Option } = Select;

const AbhaLinkedFilter = ({
  searchHide,
  filter,
  setFilter,
  setPage,
  headers,
  FilteredData,
  setFilteredData,
  filename = (val) => {},
  enableScanFilter = false,
  // Facility ID / Facility Name filter (lists whose rows have a facility)
  enableFacilityFilter = false,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [values, setValues] = useState({
    searchString: "",
    fromDate: "",
    toDate: "",
    page: 1,
    isScanned: "",
    facilityId: "",
    facilityName: "",
  });
  useEffect(() => {
    if ([...searchParams.entries()].length === 0) return;
    const searchStringFromParams = searchParams.get("searchString") || "";
    const fromDateFromParams = searchParams.get("fromDate") || "";
    const toDateFromParams = searchParams.get("toDate") || "";
    const pageFromParams = parseInt(searchParams.get("page"), 10) || 1;
    const isScannedFromParams = searchParams.get("isScanned") || "";
    const facilityIdFromParams = searchParams.get("facilityId") || "";
    const facilityNameFromParams = searchParams.get("facilityName") || "";
    setValues((prevValues) => ({
      ...prevValues,
      searchString: searchStringFromParams,
      fromDate: fromDateFromParams,
      toDate: toDateFromParams,
      page: pageFromParams,
      isScanned: isScannedFromParams,
      facilityId: facilityIdFromParams,
      facilityName: facilityNameFromParams,
    }));

    setFilter({
      searchString: searchStringFromParams,
      fromDate: fromDateFromParams,
      toDate: toDateFromParams,
      page: pageFromParams,
      isScanned: isScannedFromParams,
      facilityId: facilityIdFromParams,
      facilityName: facilityNameFromParams,
    });
  }, [searchParams]);

  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };
  const handleFilter = () => {
    const params = new URLSearchParams();
    Object.keys(values).forEach((searchParameter) => {
      if (values[searchParameter]) {
        params.set(searchParameter, values[searchParameter]);
      }
    });
    setSearchParams(params);
    setFilter({ ...filter, ...values });

    setPage(1);
  };
  const handleFilterReset = () => {
    // Reset filter state
    setFilter({});
    setValues({
      searchString: "",
      fromDate: "",
      toDate: "",
      page: 1,
      isScanned: "",
      facilityId: "",
      facilityName: "",
    });
    setPage(1);

    // Clear URL search parameters
    setSearchParams(new URLSearchParams());
  };

  // Fields share the row; buttons keep their size. One line on desktop,
  // wraps cleanly on small screens.
  const FIELD = "1 1 150px";
  const field = (label, name, input) => (
    <Col flex={FIELD} style={{ minWidth: 150 }}>
      <strong>
        <p className="mb-2">{label}</p>
      </strong>
      {input}
    </Col>
  );

  return (
    <div className="table_filter">
      <Row gutter={[16, 16]} align="bottom" wrap className="ml-10">
        {field(
          "From Date",
          "fromDate",
          <Input
            type="date"
            id="fromdate"
            autoComplete="off"
            className="form-control"
            onChange={(e) => handleChange("fromDate", e.target.value)}
            max={moment().format("YYYY-MM-DD")}
            placeholder="From Date"
            value={values?.fromDate}
          />
        )}
        {field(
          "To Date",
          "toDate",
          <Input
            type="date"
            id="todate"
            className="form-control"
            onChange={(e) => handleChange("toDate", e.target.value)}
            min={values?.fromDate}
            placeholder="To Date"
            autoComplete="off"
            value={values?.toDate}
          />
        )}
        {!searchHide &&
          field(
            "Search",
            "searchString",
            <Input
              type="text"
              autoComplete="off"
              className="form-control"
              onChange={(e) => handleChange("searchString", e.target.value)}
              placeholder="Search"
              value={values?.searchString}
            />
          )}
        {enableFacilityFilter &&
          field(
            "Facility ID",
            "facilityId",
            <Input
              type="text"
              autoComplete="off"
              className="form-control"
              onChange={(e) => handleChange("facilityId", e.target.value)}
              placeholder="e.g. IN0910034462"
              value={values?.facilityId}
            />
          )}
        {enableFacilityFilter &&
          field(
            "Facility Name",
            "facilityName",
            <Input
              type="text"
              autoComplete="off"
              className="form-control"
              onChange={(e) => handleChange("facilityName", e.target.value)}
              placeholder="Facility Name"
              value={values?.facilityName}
            />
          )}
        {enableScanFilter && (
          <Col flex="none">
            <strong>
              <p className="mb-2">Scanned Filter</p>
            </strong>
            <Radio.Group
              onChange={(e) => handleChange("isScanned", e.target.value)}
              value={values.isScanned}
              style={{ whiteSpace: "nowrap" }}
            >
              <Radio value="1">Scanned</Radio>
              <Radio value="">All</Radio>
            </Radio.Group>
          </Col>
        )}
        <Col flex="none">
          <div className="flex gap10" style={{ flexWrap: "nowrap", alignItems: "center" }}>
            <button className="filter-button" onClick={() => handleFilter()}>
              Filter
            </button>
            <button
              className="clear-button"
              onClick={() => handleFilterReset()}
            >
              Reset
            </button>
            <CSVLink
              filename={filename + ".csv"}
              data={FilteredData}
              headers={headers}
              className="ex-export2 mt-0"
              style={{ right: 0, marginTop: 0 }}
              onClick={() => {
                message.success("The file is downloading");
              }}
            >
              <Tooltip
                placement="top"
                title={"A user can download only single page data once."}
                arrow={false}
              >
                <Button className="export-csv"> Export to CSV </Button>
              </Tooltip>
            </CSVLink>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AbhaLinkedFilter;
